// #region imports

// --- Angular
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

// --- HS Code
import { NotificationModel, NotificationTypes } from '../../../models';

// #endregion

@Component({
  selector: 'hs-notification-list-empty',
  templateUrl: './notification-list-empty.component.html',
  styleUrls: ['./notification-list-empty.component.scss']
})
export class NotificationListEmptyComponent {
  @Input() notification: NotificationModel | null = null;
  @Input() markAsReadLabel: string = '';
  @Input() downloadLabel: string = '';

  @Output() view = new EventEmitter<NotificationModel>();
  @Output() remove = new EventEmitter<NotificationModel>();

  notificationTypes = NotificationTypes;

  onView(event: Event, notification: NotificationModel | null): void {
    if (!notification) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    this.view.emit(notification);
  }

  onRemove(event: Event, notification: NotificationModel | null): void {
    if (!notification) {
      return;
    }
    
    event.preventDefault();
    event.stopPropagation();
    this.remove.emit(notification);
  }
}
